import { get, call } from 'vuex-pathify';

export default {
  data: () => ({
    agreeButtonLoading: false,
  }),
  computed: {
    currentLayer: get('layers/currentLayer'),
    currentLayerScope: get('layers/currentLayer@layer_scope'), //?
    isTopo() {
      return this.isTopologicalLayer(this.currentLayer);
    },
  },
  methods: {
    deleteDatasourceFeature: call('layers/deleteDatasourceFeature'),
    deleteDatasourceFeatures: call('layers/deleteDatasourceFeatures'),
    deleteTopoDatasourceFeatures: call('layers/deleteTopoDatasourceFeatures'),
    async deleteObjectHandler() {
      if (this.isTopo) {
        const r = await this.deleteObjectHof(this.deleteTopoDatasourceFeatures);
        if (r?.data?.data) {
          this.refreshLayersAndTable(r.data.data);
        }
      } else if (this.isMoreThanOneObjectSelected) {
        await this.deleteObjectHof(this.deleteDatasourceFeatures);
      } else {
        await this.deleteObjectHof(this.deleteDatasourceFeature);
      }
      if (this.isAnyFeatureSelected) {
        this.turnOffEditing();
      }
    },
    refreshLayersAndTable(layers) {
      this.$root.$emit('refreshTableData');
      this.$root.$emit(
        'refreshMvtSources',
        layers.map(layer => ({ id: layer, group: 'layers' })),
        true
      );
      this.$root.$emit('updateLegendStylesCounts', { layersIds: layers });
    },
  },
};
